var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserDuotone1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 44,
    viewBox: "0 0 39 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6744 26.125H15.0637C6.9379 26.125 0.347412 32.7937 0.347412 41.018C0.347412 42.6628 1.66534 43.9974 3.29067 43.9974H35.4491C37.0745 44 38.3907 42.668 38.3907 41.018C38.3907 32.7937 31.8011 26.125 23.6744 26.125Z",
    fill: "#3F3030"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.2386 11C30.2386 17.0749 25.3728 22 19.3691 22C13.3654 22 8.49957 17.0758 8.49957 11C8.49957 4.92422 13.3662 0 19.3691 0C25.3728 0 30.2386 4.92508 30.2386 11Z",
    fill: "#3F3030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.0433,
    height: 44,
    fill: "white",
    transform: "translate(0.347412)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDuotone1);
export default __webpack_public_path__ + "static/media/user-duotone 1.f6a36b4286862a2f79067d33e8dc169b.svg";
export { ForwardRef as ReactComponent };